import { useEffect, useState } from 'react';
import { FilterSegmentSelectInputOption } from '../../../FilterInputsList.types';
import { createFilterSelectOption } from '../../../utils';
import { FilterSegmentSelectInput } from '../../FilterSegmentSelectInput';
import { FilterListValueOption, ListFilterOption } from './FilterListValueOption';

const createListOption = (list: ListFilterOption) =>
  createFilterSelectOption(list?.id?.toString(), <FilterListValueOption list={list} />, {
    labelInTriggerButton: list.name,
  });

type FilterListValueInputProps = {
  onChange: (value: string) => void;
  value: string;
  id: string;
  isDisabled?: boolean;
  lists: ListFilterOption[];
  isLoading: boolean;
  hasError: boolean;
  placeholder?: string;
  listType: string;
};

export const FilterListValueInput = ({
  id,
  onChange,
  value,
  isDisabled = false,
  lists,
  isLoading,
  hasError = false,
  listType = '',
  placeholder,
}: FilterListValueInputProps) => {
  const [options, setOptions] = useState<FilterSegmentSelectInputOption[]>([]);
  const [filterText, setFilterText] = useState<string>('');
  useEffect(() => {
    if (lists?.length) {
      const sortedLists = [...lists].sort((a, b) => a.name.localeCompare(b.name));
      const lowerCaseFilterText = filterText.toLowerCase();
      setOptions(
        sortedLists.reduce<FilterSegmentSelectInputOption[]>(
          (acc, list) =>
            list.id.toString().toLowerCase().includes(lowerCaseFilterText) ||
            list.name.toLowerCase().includes(lowerCaseFilterText)
              ? [...acc, createListOption(list)]
              : acc,
          [],
        ),
      );
    }
  }, [lists, filterText]);

  const displayText = {
    placeholder: `Select a ${listType}...`,
    loading: `Loading ${listType}s...`,
  };

  return (
    <FilterSegmentSelectInput
      id={id}
      onSelect={([selectedList]) => onChange(selectedList?.id || '')}
      options={options}
      placeholder={isLoading ? displayText?.loading : placeholder || displayText?.placeholder}
      selectedOptionIds={isLoading || !value.length ? [] : [value]}
      isDisabled={isDisabled || isLoading}
      isFilterable
      hasError={hasError}
      onSearchChange={(searchText) => setFilterText(searchText || '')}
    />
  );
};
